import type { CustomFont, Font, FontImport } from "src/types";

export function isFontImport(font: Font | FontImport): font is FontImport {
  return "font" in font;
}

export function isCustomFont(font: Font | CustomFont): font is CustomFont {
  return "font_faces" in font;
}
